module.exports = __webpack_public_path__ + "static/media/video.6ef1bd6c.mp4";